import React from 'react'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

import {CashbackProps} from '../../types/cashback'
import {CashbackKarma} from './karmanow'
import {CashbackWeWard} from './weward'

export interface CashbackWithCallbackProps extends CashbackProps {
  onInfoClick?: (value: number) => void
}

export const Cashback = ({
  value,
  type,
  variant = 'long',
  withInfoAction = false,
  onInfoClick
}: CashbackWithCallbackProps) => {
  const {brandCode} = useBrand()
  const {
    monetisation: {cashback}
  } = useBrandCapabilities()
  if (!value || !cashback.enabled) return null

  switch (brandCode) {
    case 'weward':
      return (
        <CashbackWeWard
          value={value}
          type={type}
          variant={variant}
          messages={cashback.config.messages}
        />
      )
    case 'karmanow':
      return (
        <CashbackKarma
          value={value}
          variant={variant}
          withInfoAction={withInfoAction}
          messages={cashback.config.messages}
          onInfoClick={onInfoClick}
        />
      )
    default:
      return null
  }
}
